// Generated by Melange

import * as Buhta_landing__ClassifierModel from "../ClassifierModel.js";
import * as Buhta_landing__UnitListView from "./UnitListView.js";
import * as Buhta_landing__UnitTableView from "./UnitTableView.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ClassifiersUnitList(Props) {
  let units = Props.units;
  const match = React.useState(function () {
    return "";
  });
  const setWord = match[1];
  const word = match[0];
  const match$1 = React.useState(function () {
    return /* [] */ 0;
  });
  const setFilteredUnits = match$1[1];
  const filteredUnits = match$1[0];
  React.useEffect((function () {
    const result = word === "" ? units : Stdlib__List.filter((function (unit) {
        if (Buhta_landing__ClassifierModel.wordFound(word, unit.code) || Buhta_landing__ClassifierModel.wordFound(word, unit.name)) {
          return true;
        } else {
          return Buhta_landing__ClassifierModel.wordFound(word, unit.short_name);
        }
      }), units);
    Curry._1(setFilteredUnits, (function (param) {
      return result;
    }));
  }), [
    word,
    units
  ]);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            className: "w-6 h-6",
            src: StaticAsset.src("/static/icons/search-24-gray.svg")
          }),
          JsxRuntime.jsx("input", {
            className: "paragraph text-black-landing w-full",
            placeholder: "Поиск...",
            type: "text",
            value: word,
            onChange: (function (ev) {
              const value = ev.target.value;
              Curry._1(setWord, (function (param) {
                return value;
              }));
            })
          })
        ],
        className: "rounded-xl shadow-toast p-4 flex gap-2 toast-card"
      }),
      JsxRuntime.jsx(Buhta_landing__UnitTableView.make, {
        units: filteredUnits
      }),
      JsxRuntime.jsx(Buhta_landing__UnitListView.make, {
        units: filteredUnits
      })
    ]
  });
}

const make = ClassifiersUnitList;

export {
  make,
}
/* Buhta_landing__UnitListView Not a pure module */
